module.exports = __webpack_public_path__ + "static/media/home2.04b52f17.jpg";